export const pickAudioMime = (): { mimeType?: string; ext: string } => {
  // Order matters – first supported wins
  const candidates: [string, string][] = [
    ["audio/webm;codecs=opus", "webm"],
    ["audio/webm", "webm"],
    ["audio/mp4", "m4a"], // Safari iOS ≥ 14
    ["audio/aac", "aac"],
  ];

  for (const [type, ext] of candidates) {
    if (MediaRecorder.isTypeSupported(type)) return { mimeType: type, ext };
  }
  return { ext: "raw" }; // Fallback
};

/**
 * Determines appropriate file extension based on audio MIME type
 */
export const getAudioExtensionFromMime = (mimeType: string): string => {
  if (mimeType.includes("webm")) return "webm";
  if (mimeType.includes("ogg")) return "ogg";
  if (mimeType.includes("wav")) return "wav";
  if (mimeType.includes("aac")) return "aac";
  if (mimeType.includes("mpeg") || mimeType.includes("mp3")) return "mp3";
  // Default to mp4 for most mobile recordings
  return "mp4";
};

/**
 * Creates an audio file from blob with appropriate naming and type
 */
export const createAudioFile = (blob: Blob, prefix = "voice"): File => {
  const mimeType = blob.type || "audio/mp4";
  const ext = getAudioExtensionFromMime(mimeType);
  return new File([blob], `${prefix}-${Date.now()}.${ext}`, { type: mimeType });
};
